var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconClearField = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 19,
  viewBox: "0 0 19 19",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#0944B3",
  cx: 9.5,
  cy: 9.5,
  r: 9.5
}), /*#__PURE__*/React.createElement("path", {
  d: "m5.188 5.187 8.625 8.625m0-8.625-8.625 8.625",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}))));
export { SvgIconClearField as ReactComponent };
export default __webpack_public_path__ + "assets/images/icon-clear-field.svg";